type Article = {
  title: string;
  imageSrc?: string;
  description: string;
  url: string;
  pageTitle: string;
  profileImage: string;
};

type SubtopicData = {
  articles: Array<Article>;
};

type SubtopicPagesData = {
  subtopic: Map<string, SubtopicData>;
};

const SubtopicData: Array<SubtopicData> = [
  {
    articles: [
      {
        pageTitle: 'MICHAEL HANS HAHL',
        title:
          'Klartext mit dem Entscheider! Jetzt dreht die Generation 50+ den „Spieß“ des Bewerbungsprozesses um',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/004/452/476/web_high/06c09e4d0ea29300c8438d574f388324befa282cimage.jpg?1646322716',
        description:
          'Bewerbung geschrieben, versandt. Hoffnung keimt auf. Die kleine Pflanze, die so prächtig aufblühen könnte, wird durch eine – in den seltensten Fällen nachvollziehbare',
        url: 'https://www.xing.com/news/insiders/articles/klartext-mit-dem-entscheider-jetzt-dreht-die-generation-50-den-spiess-des-bewerbungsprozesses-um-4652800',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/174/690/square_48/d4fb0159ac82014bf8c0702998171f1656d01241image.jpg?1667293710',
      },
      {
        pageTitle: 'Stefanie Saß',
        title:
          'Die perfekte Bewerbung nach Studienabschluss: Worauf Personaler wirklich achten',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/002/348/979/web_high/26ccca98f93c158788895863ad3b5b233a993894image.jpg?1565011055',
        description:
          'Vor kurzem war ich im Gespräch mit einem befreundeten Personaler aus der Immobilienbranche. Dabei haben wir uns unter anderem die Frage gestellt – was macht perfekte Bewerber*innen eigentlich aus?',
        url: 'https://www.xing.com/news/insiders/articles/die-perfekte-bewerbung-nach-studienabschluss-worauf-personaler-wirklich-achten-2500579',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/827/205/square_48/d10d1eaa9d61a370602f1aaef7fe71a386653c75image.jpg?1621573800',
      },
      {
        pageTitle: 'Job & Karriere Schweiz',
        title:
          'Was tun, wenn Sie auf dem gewöhnlichen Bewerbungsweg nicht erfolgreich sind?',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/001/864/968/web_high/036129cdfe029942dbd0e8509ac24916e1ee7506image.jpg?1547563595',
        description:
          'Wir – das News & Content Team XING Schweiz – empfehlen Ihnen regelmässig lesenswerte Beiträge aus dem Bereich "Job & Karriere“. ',
        url: 'https://www.xing.com/news/articles/was-tun-wenn-sie-auf-dem-gewohnlichen-bewerbungsweg-nicht-erfolgreich-sind-1984095',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/095/079/square_48/2997b31d8fb51f5b1de30310812a928c3d6b6838image.jpg?1592558965',
      },
      {
        pageTitle: 'Jochen Mai',
        title: 'Mit Wutbewerbungen gegen zu wenig Wertschätzung',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/343/141/web_high/481f87f154da7e89044a23afa2f4a4b2f56594f8image.jpg?1673982130',
        description:
          'Jeder dritte Arbeitnehmer würde am liebsten noch in den kommenden sechs Monaten seinen Job wechseln. ',
        url: 'https://www.xing.com/news/insiders/articles/mit-wutbewerbungen-gegen-zu-wenig-wertschatzung-5434697',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/004/822/523/square_48/ece1be35ac76c183e662e40eff97fdc1c49b8255image.jpg?1653460545',
      },
      {
        pageTitle: 'Frank Rechsteiner',
        title:
          'So erhöhst du deutlich deine Chancen: Die Bewerbung der Zukunft',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/004/352/095/web_high/0810548360ebfacfb89a9a912fec984702b8ed64image.jpg?1643713479',
        description:
          'Früher wurde von Unternehmen Anschreiben, Lebenslauf, Projektliste und noch Zeugnisse für eine ordentliche Bewerbung gewünscht.',
        url: 'https://www.xing.com/news/insiders/articles/so-erhohst-du-deutlich-deine-chancen-die-bewerbung-der-zukunft-4570278',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/329/685/square_48/b8952f0b96f0b2d1ce1c7c83f870a4125f11671eimage.jpg?1673458667',
      },
      {
        pageTitle: 'Job & Karriere',
        title: 'Vorsicht: Das hat sich bei modernen Bewerbungen geändert',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/001/537/312/web_high/8bc449e79d6b13635da78ace644a6d8c940d5b29image.jpg?1534760902',
        description:
          'Was bewegt die Arbeitswelt heute? In unserer Artikelsammlung erklären wir aktuelle Aspekte, beleuchten unterschiedliche Perspektiven und empfehlen Hintergrundbeiträge – direkt aus der XING-Redaktion.',
        url: 'https://www.xing.com/news/articles/vorsicht-das-hat-sich-bei-modernen-bewerbungen-geandert-1628897',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Job & Karriere Schweiz',
        title: 'Eine Absage jagt die nächste? Das hilft gegen Bewerbungsfrust',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/351/941/web_high/10799a5c2c16355dc97f085c89031bae54a2ca27image.jpg?1565098033',
        description:
          'Bewerbungen sind für viele ein Buch mit sieben Siegeln. Manchmal klappt es beim ersten Versuch, zu anderen Zeiten gibt es nur Absagen.',
        url: 'https://www.xing.com/news/articles/eine-absage-jagt-die-nachste-das-hilft-gegen-bewerbungsfrust-2503864',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/095/079/square_48/2997b31d8fb51f5b1de30310812a928c3d6b6838image.jpg?1592558965',
      },
      {
        pageTitle: 'NWX – New Work News',
        title: 'Richtig frech: Über diese Bewerber lachen Personaler',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/003/347/518/web_high/5d2b4d015feec67123f4f1e4683ad8a6f151c32bimage.jpg?1601895259',
        description:
          'Wer denkt, jeden Tag zahlreiche Bewerbungen zu lesen, sei langweilig, der hat sich mächtig getäuscht. Denn die Personaler haben dabei oft eine Menge zum Lachen.',
        url: 'https://www.xing.com/news/articles/richtig-frech-uber-diese-bewerber-lachen-personaler-3530943',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/002/498/801/square_48/fbbd8bd5998209b82b8efffcda32c77e791c3231image.jpg?1569938668',
      },
      {
        pageTitle: 'Job & Karriere',
        title:
          'HR-Praxistipps: So klappt die Bewerbung als Berufseinsteiger·in!',
        description:
          'Die Arbeitswelt steht im Wandel und so natürlich auch der Bewerbungsprozess. Was für die Eltern normal war, wird jetzt in Frage gestellt: Schicke ich noch ein Anschreiben mit? Und wie formell muss ich mich kleiden?',
        url: 'https://www.xing.com/news/articles/hr-praxistipps-so-klappt-die-bewerbung-als-berufseinsteiger-in-4893359',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'XING Talk',
        title:
          'Erfolgreich bewerben nach der Elternzeit: Mit mehr Selbstvertrauen in den Wiedereinstieg',
        description:
          'Eine Bewerbung ist immer eine Herausforderung. Besonders gilt das nach mehreren Monaten oder gar Jahren Pause. Wer die Rückkehr in den Beruf nach der Elternzeit wagt, ist häufig von Selbstzweifeln geplagt.',
        url: 'https://www.xing.com/news/articles/erfolgreich-bewerben-nach-der-elternzeit-mit-mehr-selbstvertrauen-in-den-wiedereinstieg-2599753',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/933/255/square_48/fc59eef108434f54b9e78aa98765278644372177image.jpg?1508401741',
      },
      {
        pageTitle: 'XING Talk',
        title:
          'Bewerbung mit 50 plus: Darauf müssen ältere Arbeitnehmer achten',
        description:
          'Wer mit 50 Jahren arbeitslos wird, gilt oft als „schwer vermittelbar“. Schuld sei das Alter, sagen die Betroffen. Dennoch sollten sie die Hoffnung nicht vorschnell aufgeben, meint Karriereberaterin Barbara Simonsen im aktuellen XING Talk: „Die Wissenschaft bestätigt: Der Erfahrungswert der älteren Mitarbeiter ist für Firmen immens wichtig.“',
        url: 'https://www.xing.com/news/articles/bewerbung-mit-50-plus-darauf-mussen-altere-arbeitnehmer-achten-1080312',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/933/255/square_48/fc59eef108434f54b9e78aa98765278644372177image.jpg?1508401741',
      },
      {
        pageTitle: 'Lars Hahn',
        title:
          'Jobsuche 2023: Warum eine Bewerbung per ChatGPT noch keine gute Idee ist',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZjc3NGIwMjctYWI0Yi00NjAwLTljZTUtYTkxOTA4MjEwZmQ2IiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=59b478f00d1ca446ce26a564f9a8a803f9b7f53387f85aa14e0a09c11ebbc95a',
        description:
          'Künstliche Intelligenz ist gerade dabei, unsere Arbeitswelt zu erobern. Mit Chat GPT kann man bereits Texte automatisiert erstellen lassen, also auch Bewerbungsanschreiben und Co. Eine gute Idee, oder eher nicht?',
        url: 'https://www.xing.com/news/article/jobsuche-2023-warum-eine-bewerbung',
        profileImage:
          'https://profile-images.xing.com/images/b62adc10428ce9e8db9a0a96aa332617-42/lars-hahn.256x256.jpg',
      },
    ],
  },
  {
    articles: [
      {
        pageTitle: 'Job & Karriere Schweiz',
        title: 'Bewerbung als Berufseinsteiger: Tipps zum Durchstarten',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/409/602/web_high/b56ce80e6158e65767420cce857157d3023afcabimage.jpg?1567065012',
        description:
          'Endlich fertig mit der Ausbildung oder dem Studium und bereit, um Karriere zu machen? Viele Berufseinsteiger starten hoch motiviert in den Bewerbungsprozess – und schnell folgt die Ernüchterung. Wie also können Sie wirklich durchstarten?',
        url: 'https://www.xing.com/news/articles/bewerbung-als-berufseinsteiger-tipps-zum-durchstarten-2565890',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/095/079/square_48/2997b31d8fb51f5b1de30310812a928c3d6b6838image.jpg?1592558965',
      },
      {
        pageTitle: 'NWX – New Work News',
        title:
          'Bewerben über TikTok? So verändert die Digitalisierung den Bewerbungsprozess',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/003/351/291/web_high/4a4824ff032f6ad264026ba4899cd6a2bae09080image.jpg?1601997938',
        description:
          'Über TikTok, Turbokapitalismus und die neue Attraktivität von Personalmanagement',
        url: 'https://www.xing.com/news/articles/bewerben-uber-tiktok-so-verandert-die-digitalisierung-den-bewerbungsprozess-3534832',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/002/498/801/square_48/fbbd8bd5998209b82b8efffcda32c77e791c3231image.jpg?1569938668',
      },
      {
        pageTitle: 'Job & Karriere Schweiz',
        title: 'Boomerang-Bewerbung: Hallo, da bin ich wieder!',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/748/085/web_high/cf93b89b3049faa1c54a5853e9d9636f26a3bbb1image.jpg?1579513327',
        description:
          'Du hast deinen alten Arbeitgeber für einen neuen Job verlassen und möchtest jetzt wieder zurück? Damit eine Boomerang-Bewerbung gelingt, brauchst du vor allem eines: gute Argumente. Wir haben bei Personalern nachgefragt, wie du überzeugen kannst und die Rückkehr gelingt.',
        url: 'https://www.xing.com/news/articles/boomerang-bewerbung-hallo-da-bin-ich-wieder-2924298',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/095/079/square_48/2997b31d8fb51f5b1de30310812a928c3d6b6838image.jpg?1592558965',
      },
      {
        pageTitle: 'Job & Karriere Schweiz',
        title:
          'Hallo, hier bin ich: So wird eine gute Initiativbewerbung aufgebaut',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/441/689/web_high/35e4de8171742fd0551f2a3f35828b004c66016cimage.jpg?1568117416',
        description:
          'Stell dir vor, du hast gerade gelesen, in welchen Unternehmen die Mitarbeiter mit ihren Löhnen am glücklichsten sind. Jetzt siehst du vor deinem inneren Auge natürlich nur noch dicke Scheine und hättest dich am liebsten schon gestern bei diesen Arbeitgebern beworben.',
        url: 'https://www.xing.com/news/articles/hallo-hier-bin-ich-so-wird-eine-gute-initiativbewerbung-aufgebaut-2600415',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/095/079/square_48/2997b31d8fb51f5b1de30310812a928c3d6b6838image.jpg?1592558965',
      },
      {
        pageTitle: 'XING Talk',
        title:
          'Online statt analog: Wie sich mit digitalen Bewerbungen punkten lässt',
        description:
          'Schnelligkeit und Flexibilität – das sind Eigenschaften, die viele Bewerber heutzutage mitbringen sollten. Und diese sind bereits im Bewerbungsprozess gefragt. Immer mehr Firmen haben die analoge Bewerbungsmappe aussortiert, setzen auf digitale Auswahlstrukturen. ',
        url: 'https://www.xing.com/news/articles/online-statt-analog-wie-sich-mit-digitalen-bewerbungen-punkten-lasst-2224307',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/933/255/square_48/fc59eef108434f54b9e78aa98765278644372177image.jpg?1508401741',
      },
      {
        pageTitle: 'Job & Karriere',
        title: 'Tipps für die Initiativbewerbung',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/000/755/747/web_high/4619eb967531d5656fd665dc3ead012d00fc9d91image.jpg?1499246421',
        description:
          'Sie möchten gern für ein bestimmtes Unternehmen tätig werden, aber es sind aktuell keine Stellen ausgeschrieben? Wir zeigen Ihnen, wann sich eine Initiativbewerbung lohnt und wie Sie damit punkten.',
        url: 'https://www.xing.com/news/articles/tipps-fur-die-initiativbewerbung-810347',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Joachim Diercks',
        title:
          'Online-Einstellungstests und deren Wirkung als Personalmarketing-Instrument. Spannender Studienbefund (TH Brandenburg)',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/003/626/286/web_high/0afc1112512b2891b7f36a9d44d0824bc984a041image.jpg?1613467745',
        description:
          'Früher hieß es: Tests mag niemand. Das ganze wurde elaborierter unter der Überschrift “Soziale Validität” diskutiert, aber der Tenor war im Grunde immer gleich.',
        url: 'https://www.xing.com/news/insiders/articles/online-einstellungstests-und-deren-wirkung-als-personalmarketing-instrument-spannender-studienbefund-th-brandenburg-3814780',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/121/043/square_48/95b3fb654f0c8fbc3c85d1dc5154a4d157590cddimage.jpg?1593584891',
      },
      {
        pageTitle: 'NWX – New Work News',
        title:
          'Digital Bewerben: Warum der Trend für mehr Objektitivät im Auswahlverfahren sorgen kann',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/003/350/106/web_high/1e53f972776f844a48199a5abc17510c96b0967bimage.jpg?1601978102',
        description:
          'Prof. Dr. Uwe Kanning, Hochschule Osnabrück, Professor für Wirtschaftspsychologie, gilt als Personaldiagnostikexperte und hat sich um die Aufklärung über Pseudowissenschaften in der Personalauswahl und im Personalmanagement verdient gemacht.',
        url: 'https://www.xing.com/news/articles/digital-bewerben-warum-der-trend-fur-mehr-objektitivat-im-auswahlverfahren-sorgen-kann-3533450',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/002/498/801/square_48/fbbd8bd5998209b82b8efffcda32c77e791c3231image.jpg?1569938668',
      },
      {
        pageTitle: 'Joachim Diercks',
        title: 'Bewerbung über WhatsApp-Chatbot. Das geht jetzt bei DPDHL…',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/002/093/881/web_high/5123189dff4a652d55a48d07f4c6c0c7bc91d8f2image.jpg?1555488519',
        description:
          'Es wird momentan viel über den Einsatz von Bots und Algorithmen im Recruiting gesprochen, auch hier im Blog. Aber so spannend die akademische Debatte über Fürs und Widers dabei ist, manchmal hilft es auch, wenn es mal konkret wird. Also praktische Anschauungsbeispiele.',
        url: 'https://www.xing.com/news/insiders/articles/bewerbung-uber-whatsapp-chatbot-das-geht-jetzt-bei-dpdhl-2227939',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/121/043/square_48/95b3fb654f0c8fbc3c85d1dc5154a4d157590cddimage.jpg?1593584891',
      },
      {
        pageTitle: 'Silke Grotegut',
        title:
          'Job ohne Stellenanzeige: So kommst du an den verdeckten Arbeitsmarkt',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/004/878/429/web_high/8d7b3fba6965e045c245f6048d0b5f156fbb1aacimage.jpg?1655822742',
        description:
          'Je höher die Position, desto wichtiger, fast alternativlos, wird der sogenannte verdeckte Arbeitsmarkt. Geschätzt 70 Prozent aller Stellen werden ohne Stellenausschreibung besetzt.',
        url: 'https://www.xing.com/news/insiders/articles/job-ohne-stellenanzeige-so-kommst-du-an-den-verdeckten-arbeitsmarkt-4947689',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/004/323/625/square_48/6c3ce2f8c742f956d092bb72b5f2a5fbb6e31aa9image.jpg?1642595389',
      },
    ],
  },
  {
    articles: [
      {
        pageTitle: 'Campus & Karriere',
        title: "Authentizität im Anschreiben: Wie ehrlich darf's denn sein?",
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/068/438/web_high/6ea6eedcbcce018c6d95c2ad6b1babfdb5aeb7a5image.jpg?1554474326',
        description:
          'Klar, in Ihrer Bewerbung sollten Sie sich ehrlich präsentieren und langweilige Standard-Anschreiben vermeiden. Doch wie viel Authentizität ist taktisch klug?',
        url: 'https://www.xing.com/news/articles/authentizitat-im-anschreiben-wie-ehrlich-darf-s-denn-sein-2201225',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/270/889/square_48/image.jpg?1464946715',
      },
      {
        pageTitle: 'Bewerbung & Gehaltsverhandlung',
        title: 'So sollte der erste Satz im Anschreiben aussehen',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/233/497/web_high/705bd21c7117b16788f1337f56b3987ee43553b8image.jpg?1560503549',
        description:
          'Wenn es Ihnen gelingt, mit Ihrem Anschreibens Interesse zu wecken und den Leser neugierig zu machen, steigen die Chancen für ein Vorstellungsgespräch deutlich. Denn auch wenn Personaler verschieden sind: nichtssagendes Gerede mag keiner.',
        url: 'https://www.xing.com/news/articles/so-sollte-der-erste-satz-im-anschreiben-aussehen-2378708',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/939/708/square_48/0237a55a3e4987ea2a9afdbfed060a544c5a5ba9image.jpg?1508772598',
      },
      {
        pageTitle: 'Job & Karriere',
        title: 'So überzeugen Sie im Bewerbungsschreiben',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/000/746/919/web_high/daf4f2d4cbbfac397a575ed0bcc468778d86dfe3image.jpg?1498746831',
        description:
          'Oft ist das Formulieren eines aussagekräftigen Bewerbungsschreibens eine Herausforderung für Bewerber. Wer diese Tipps beherzigt, der hat die Arbeit schon halb erledigt.',
        url: 'https://www.xing.com/news/articles/so-uberzeugen-sie-im-bewerbungsschreiben-801323',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Nane Nebel',
        title:
          'Bewerbungsanschreiben – Machen sie überhaupt noch Sinn? Ja! Wenn das Richtige drin steht.',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/001/510/329/web_high/cb5e0d068c5e21b37b1cbc4da8943ec46d633bbcimage.jpg?1533644994',
        description:
          'Immer mehr Unternehmen verzichten bei den elektronisch erbetenen Bewerbungsunterlagen auf das Mitschicken eines klassischen Bewerbungsanschreibens. Die dafür genannten Gründe sind vielfältig.',
        url: 'https://www.xing.com/news/insiders/articles/bewerbungsanschreiben-machen-sie-uberhaupt-noch-sinn-ja-wenn-das-richtige-drin-steht-1599238',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/329/622/square_48/d654cd0fac7b046bc01a013d2c43eb6fc37d84f6image.jpg?1673457989',
      },
      {
        pageTitle: 'Joachim Diercks',
        title:
          'Ist das ein Anschreiben oder kann das weg? Machen Cover Letter Sinn oder sollte man sie abschaffen?',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/003/019/651/web_high/e86813d3de3ffa0e9667ce6c6c30664d47ee533bimage.jpg?1589552537',
        description:
          'Das Thema ist ja fast schon ein Klassiker: Brauchen wir das Anschreiben noch?',
        url: 'https://www.xing.com/news/insiders/articles/ist-das-ein-anschreiben-oder-kann-das-weg-machen-cover-letter-sinn-oder-sollte-man-sie-abschaffen-3203261',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/121/043/square_48/95b3fb654f0c8fbc3c85d1dc5154a4d157590cddimage.jpg?1593584891',
      },
      {
        pageTitle: 'Bewerbung & Gehaltsverhandlung',
        title: 'Bewerbungen sind wie Dating: Do’s und Don’ts beim Anschreiben',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/004/036/296/web_high/d39fad417056ddd39cf66b65b9625197bedcf03cimage.jpg?1630582363',
        description:
          'Bei der Bewerbung auf eine Stellenanzeige gibt es so einiges zu beachten. Im Grunde ist eine Bewerbung wie Dating: Der erste Eindruck zählt, Dein Gegenüber will umgarnt werden und wer langweilig ist, hat schlechte Karten.',
        url: 'https://www.xing.com/news/articles/bewerbungen-sind-wie-dating-do-s-und-don-ts-beim-anschreiben-4241669',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/939/708/square_48/0237a55a3e4987ea2a9afdbfed060a544c5a5ba9image.jpg?1508772598',
      },
      {
        pageTitle: 'XING Talk',
        title:
          'Bewerbungsschreiben: „Klarheit schaffen und Kante zeigen machen den Unterschied aus“',
        description:
          'Es ist der erste Eindruck, der zählt – und der ist im besten Fall positiv. Das Bewerbungsschreiben ist noch immer das Aushängeschild des Arbeitnehmers. Entsprechend groß ist die Unsicherheit, wie dieses idealerweise gestaltet werden sollte.',
        url: 'https://www.xing.com/news/articles/bewerbungsschreiben-klarheit-schaffen-und-kante-zeigen-machen-den-unterschied-aus-1258352',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/933/255/square_48/fc59eef108434f54b9e78aa98765278644372177image.jpg?1508401741',
      },
      {
        pageTitle: 'Job & Karriere',
        title: 'Erfolgreichere Bewerbungen dank Schreibtraining?',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/001/836/606/web_high/581923f5452f8d0b3a7a342cdd1009f76b5c259eimage.jpg?1546436070',
        description:
          'Ein fesselndes Anschreiben und ein überzeugendes Motivationsschreiben zu formulieren, ist keine leichte Aufgabe. Zum Glück gibt es professionelle Berater, die ihre Unterstützung mitunter sogar kostenlos anbieten. Doch was bringt so ein Schreibtraining wirklich?',
        url: 'https://www.xing.com/news/articles/erfolgreichere-bewerbungen-dank-schreibtraining-1953295',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Campus & Karriere',
        title:
          'Floskel oder Chance – das Bewerbungsanschreiben als Auslaufmodell?',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/170/919/web_high/e67ed69d87d1e045a50ba63531b6fa7174d8daa0image.jpg?1558353637',
        description:
          'Die Deutsche Bahn vereinfachte die Bewerbung auf Azubi-Stellen und verzichtete auf das Bewerbungsanschreiben – das machte sich prompt bemerkbar. Auch andere Firmen gehen diesen Weg. Wird sich der Klassiker im Bewerbungspaket weiter halten?',
        url: 'https://www.xing.com/news/articles/floskel-oder-chance-das-bewerbungsanschreiben-als-auslaufmodell-2311115',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/270/889/square_48/image.jpg?1464946715',
      },
      {
        pageTitle: 'Campus & Karriere',
        title: 'Master-Bewerbung: Worauf es beim Motivationsschreiben ankommt',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/378/250/web_high/0b801e56f5b36c8d3baf43e4890c89f275ffca82image.jpg?1565955323',
        description:
          'Persönliches statt Floskeln: Das ist wohl die wichtigste Regel beim Motivationsschreiben für die Uni-Bewerbung. Wer überzeugend schreibt, kann manchmal sogar fehlende Voraussetzungen ausgleichen.',
        url: 'https://www.xing.com/news/articles/master-bewerbung-worauf-es-beim-motivationsschreiben-ankommt-2532166',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/270/889/square_48/image.jpg?1464946715',
      },
    ],
  },
  {
    articles: [
      {
        pageTitle: 'Dr. Alexandra Hildebrandt',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/002/831/687/web_high/05d04468d4ff8ef78456561d096c9d7904ccdcf4image.jpg?1582725502',
        title:
          'Vorstellungsgespräche erfolgreich meistern: Die wichtigsten Tipps von Personalexperten',
        description:
          'Bevor es zum eigentlichen Vorstellungsgespräch kam, gab es Mitte der achtziger Jahre in öffentlichen Institutionen und Großunternehmen noch sogenannte Einstellungstests: Je nachdem wie attraktiv ein Unternehmen war, nahmen an einem solchen',
        url: 'https://www.xing.com/news/insiders/articles/vorstellungsgesprache-erfolgreich-meistern-die-wichtigsten-tipps-von-personalexperten-3010326',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/127/450/square_48/5660ce2c010144ac56287ca70d773e341e7f04d6image.jpg?1593733714',
      },
      {
        pageTitle: 'Silke Koppitz',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/574/718/web_high/1ff707e77d2423c3dda0e13dba7da6672b437d14image.jpg?1682439772',
        title:
          'Warnzeichen im Vorstellungsgespräch: Wann ist es Zeit, das Weite zu suchen?',
        description:
          'Was ist die absurdeste Frage, die dir je in einem Vorstellungsgespräch gestellt wurde?* Bei diessen 10 Warnzeichen solltest du aufhorchen und (nicht nur in Gedanken) rückwärts aus dem Meeting moonwalken. ',
        url: 'https://www.xing.com/news/insiders/articles/warnzeichen-im-vorstellungsgesprach-wann-ist-es-zeit-das-weite-zu-suchen-5660878',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/504/323/square_48/806bca39750db92d12d4ad6c89bf073b6cfc43f7image.jpg?1679654675',
      },
      {
        pageTitle: 'Bernard Marr',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/003/692/021/web_high/f7d15f7ba119397c1e1057e7195066968075a4e1image.jpg?1615991755',
        title: 'Vorstellungsgespräch: Warum nur 3 Fragen wirklich zählen',
        description:
          'Natürlich kann man nie mit absoluter Sicherheit vorhersagen, wie ein Vorstellungsgespräch ablaufen wird und welche Fragen gestellt werden.',
        url: 'https://www.xing.com/news/insiders/articles/vorstellungsgesprach-warum-nur-3-fragen-wirklich-zahlen-3882414',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/004/212/333/square_48/88f11ed69dcbdff1dabcdcd2816cfc29d3143ec7image.jpg?1637745183',
      },
      {
        pageTitle: 'Tanja Herrmann-Hurtzig',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/745/160/web_high/26e1cf389fb65ce884634cfb90f5d279cd814c0cimage.jpg?1689074302',
        title: 'Outfit fürs Bewerbungsgespräch: Was soll ich bloß anziehen?',
        description:
          'Welche Kleidung du für ein Vorstellungsgespräch wählst, sollte nicht entscheidend sein. Trotzdem ist das Outfit Teil des ersten Eindrucks. Dank dieser Tipps und No-Gos fällt dir die Wahl deiner Kleidung fürs nächste Job-Interview sicher leichter.',
        url: 'https://www.xing.com/news/insiders/articles/outfit-furs-bewerbungsgesprach-was-soll-ich-bloss-anziehen-5840407',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/347/087/square_48/e87692eb2f50d319bf6eead7020970f1a19ff64fimage.jpg?1674116132',
      },
      {
        pageTitle: 'Sebastian A. Holtkemper',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/466/131/web_high/a6ea886a3268ac2d5bffeeb44683aef0b55bfef6image.jpg?1678355644',
        title:
          'Stelle diese strategischen Schlussfragen im Bewerbungsgespräch, wenn Du den Job willst!',
        description:
          'Jeder kennt es – Du befindest dich im Job-Interview, und dieses neigt sich dem Ende zu und der/die Interviewende schließt das Gespräch mit folgender Frage ab',
        url: 'https://www.xing.com/news/insiders/articles/stelle-diese-strategischen-schlussfragen-im-bewerbungsgesprach-wenn-du-den-job-willst-5559685',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/906/889/square_48/0959f015a73aee4544c0c0e9d73d2d4a0b5891caimage.jpg?1695350993',
      },
      {
        pageTitle: 'Stefanie Saß',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/002/429/122/web_high/61bf45f2f9ffe87075b11ba59280e97c10b64122image.jpg?1567679458',
        title:
          'Körpersprache im Vorstellungsgespräch – worauf Personaler*innen wirklich achten',
        description:
          'Wie der ideale Lebenslauf aussieht, habe ich unter anderem schon in meinem Artikel "Die perfekte Bewerbung nach Studienabschluss" angeschnitten. ',
        url: 'https://www.xing.com/news/insiders/articles/korpersprache-im-vorstellungsgesprach-worauf-personaler-innen-wirklich-achten-2586829',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/827/205/square_48/d10d1eaa9d61a370602f1aaef7fe71a386653c75image.jpg?1621573800',
      },
      {
        pageTitle: 'Sebastian A. Holtkemper',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/612/302/web_high/978f982f1abe855865002dc7ba746fe2434abb95image.jpg?1683820384',
        title:
          'Blick in die Kamera, kein vogelwilder Video-Call-Name: Deine perfekte Vorbereitung für das Online-Bewerbungsgespräch',
        description:
          'Im Zeitalter der fortgeschrittenen Technologien wird es für Arbeitgeberinnen immer komfortabler und günstiger, Vorstellungsgespräche online durchzuführen. Es gibt ein paar Fallen, in die du nicht tappen solltest.',
        url: 'https://www.xing.com/news/insiders/articles/blick-in-die-kamera-kein-vogelwilder-video-call-name-deine-perfekte-vorbereitung-fur-das-online-bewerbungsgesprach-5708678',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/906/889/square_48/0959f015a73aee4544c0c0e9d73d2d4a0b5891caimage.jpg?1695350993',
      },
      {
        pageTitle: 'Silke Koppitz',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/753/948/web_high/763a7dc5a5685c0f21d261ac1b1344749a6f6464image.jpg?1689328685',
        title:
          'Die Macht der Kleidung: Dein versteckter Kompass fürs Vorstellungsgespräch',
        description:
          'Vor ein paar Jahren wäre ein Artikel über „Kleidung im Vorstellungsgespräch“ ziemlich kurz ausgefallen: „Mit einem weißen Hemd/Bluse und dunkelblauem Anzug kannst du nichts falsch machen. Hier sind ein paar Links, viel Spaß beim Shoppen und viel Erfolg.“',
        url: 'https://www.xing.com/news/insiders/articles/die-macht-der-kleidung-dein-versteckter-kompass-furs-vorstellungsgesprach-5850835',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/504/323/square_48/806bca39750db92d12d4ad6c89bf073b6cfc43f7image.jpg?1679654675',
      },
      {
        pageTitle: 'Tanja Herrmann-Hurtzig',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/630/317/web_high/f52cf8d859be3afe36b38e95b708dd94ba7378a3image.jpg?1684608277',
        title: 'Hilfe Vorstellungsgespräch! So senkst Du Dein Stress-Level',
        description:
          'Endlich ist er da, der Termin zum Vorstellungsgespräch! Doch oh Schreck, wie bereite ich mich vor? Was ist wichtig, und wie wirke ich souverän?',
        url: 'https://www.xing.com/news/insiders/articles/hilfe-vorstellungsgesprach-so-senkst-du-dein-stress-level-5728528',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/347/087/square_48/e87692eb2f50d319bf6eead7020970f1a19ff64fimage.jpg?1674116132',
      },
      {
        pageTitle: 'Dr. Bernd Slaghuis',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/595/160/web_high/f11f6b034eccb6773b48889e8b4b0cddb3c7bf9eimage.jpg?1683204261',
        title: 'Dein erstes Bewerbungsgespräch: Warum Du nur gewinnen kannst',
        description:
          'Du bist das erste Mal zu einem Vorstellungsgespräch eingeladen? Keine Panik! Mit diesen Tipps wirst auch Du selbstbewusster und entspannter in das Gespräch gehen. Denn klar ist: Du kannst jetzt nur gewinnen.',
        url: 'https://www.xing.com/news/insiders/articles/dein-erstes-bewerbungsgesprach-warum-du-nur-gewinnen-kannst-5692460',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/786/767/square_48/1fc60bb470b3e42e790126a6eb6529183981db0eimage.jpg?1690622987',
      },
      {
        pageTitle: 'Job & Karriere',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/005/566/621/web_high/3feddc6e094395369246722c63bc8ef1a203f144image.jpg?1682076739',
        title:
          '"Red Flags" im Vorstellungsgespräch: 10 Anzeichen, dass Du dich auf eine tickende Zeitbombe einlässt',
        description:
          'Wer sich auf einen neuen Job bewirbt, sollte genau prüfen, auf was er oder sie sich einlässt. Doch keine Sorge, wir zeigen Dir, worauf Du im Vorstellungsgespräch unbedingt achten solltest.',
        url: 'https://www.xing.com/news/articles/red-flags-im-vorstellungsgesprach-10-anzeichen-dass-du-dich-auf-eine-tickende-zeitbombe-einlasst-5660526',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Job & Karriere',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/001/173/522/web_high/5ca7a6661cc04b46cd14a320a3394f5fb2cd3423image.jpg?1520247265',
        title:
          'So bereiten Sie sich auf die häufigsten Fragen im Vorstellungsgespräch richtig vor',
        description:
          'Alte Fragen und neue Methoden, harte Fakten und lockere Plauderei: Bewerber müssen in Vorstellungsgesprächen zunehmend unterschiedliche Anforderungen erfüllen. Vorbereitung lohnt sich da weiterhin - auswendig lernen müssen Bewerber aber nichts.',
        url: 'https://www.xing.com/news/articles/so-bereiten-sie-sich-auf-die-haufigsten-fragen-im-vorstellungsgesprach-richtig-vor-1240533',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Bewerbung & Gehaltsverhandlung',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/831/923/web_high/589130ff5a7b8839aa3fd687e34b4d11ff296bd7image.jpg?1582727931',
        title:
          'Typische Fragen im Vorstellungsgespräch und die besten Antworten darauf',
        description:
          'Sie sind auf der Suche nach einem neuen Job, sind auf die richtige Stelle gestoßen, haben sich beworben und bekommen eine Einladung zum Vorstellungsgespräch. Auf die riesige Freude folgt allerdings auch schnell die Aufregung. Denn Fragen in Vorstellungsgesprächen können fies sein. ',
        url: 'https://www.xing.com/news/articles/typische-fragen-im-vorstellungsgesprach-und-die-besten-antworten-darauf-3010316',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/939/708/square_48/0237a55a3e4987ea2a9afdbfed060a544c5a5ba9image.jpg?1508772598',
      },
      {
        pageTitle: 'Nane Nebel',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/529/351/web_high/c87744a176a35a2554629b34bc9546c0c11c93b1image.jpg?1680611735',
        title:
          'Bewerbungsgespräche aktiv gestalten: 4 mögliche Interviewsituationen und wie Sie sich darin selbstbewusst verhalten',
        description:
          'Das Bewerbungsgespräch ist ein gegenseitiges Kennenlernen und kein Einbahnstraßen-Interview. In meinem Xing ProJobs Webinar „Bewerbungsgespräche aktiv gestalten“ habe ich erklärt, dass Sie es mit in der Hand haben, wie ein Gespräch verläuft.',
        url: 'https://www.xing.com/news/insiders/articles/bewerbungsgesprache-aktiv-gestalten-4-mogliche-interviewsituationen-und-wie-sie-sich-darin-selbstbewusst-verhalten-5617614',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/881/465/square_48/ed0d6b64dc93cf1144a279de7d04a197913af312image.jpg?1694434114',
      },
      {
        pageTitle: 'Yvonne de Bark',
        title: 'Bewerbungsgespräch online – tappe nicht in diese Fallen',
        description:
          '„Wir machen das Jobinterview per Videocall, ich schicke Ihnen den Link.“',
        url: 'https://www.xing.com/news/insiders/articles/bewerbungsgesprach-online-tappe-nicht-in-diese-fallen-4534515',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/127/508/square_48/c6b95a7a14c27644e173c4e112ce125929316f8dimage.jpg?1593742151',
      },
      {
        pageTitle: 'Job & Karriere',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/005/726/942/web_high/10040e2b3a629bb293dcf731dd736766c78a5939image.jpg?1688392530',
        title:
          'Kennst Du die richtige Antwort? An dieser einen Frage scheitern 199 von 200 Bewerbern',
        description:
          'Bewerber•innen wissen, dass sie sich kluge Antworten zurechtlegen müssen. Doch diese eine Challenge im Vorstellungsgespräch lässt fast jede•n verzweifeln.',
        url: 'https://www.xing.com/news/articles/kennst-du-die-richtige-antwort-an-dieser-einen-frage-scheitern-199-von-200-bewerbern-5826057',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'FOCUS online: Karriere',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/691/976/web_high/251c54c1e0e132d07dce1bdebaad403626e387edimage.jpg?1576489970',
        title:
          'Fünf Fragen, die Sie Ihrem zukünftigen Chef im Vorstellungsgespräch stellen sollten',
        description:
          'Es sind ja vor allem die Bewerber, die im Vorstellungsgespräch ausgefragt werden. Allerdings sollten auch die Kandidaten für den Job sich nach ein paar Dingen erkundigen, um zu erfahren, ob der Arbeitgeber wirklich der richtige für sie ist.',
        url: 'https://www.xing.com/news/articles/funf-fragen-die-sie-ihrem-zukunftigen-chef-im-vorstellungsgesprach-stellen-sollten-2867120',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/004/960/809/square_48/1082aef57936dcb978bb4ea9731815c9fbebf567image.jpg?1658947352',
      },
      {
        pageTitle: 'XING Insider',
        title:
          'Mach Dich nicht kleiner, als Du bist! 8 Tipps, wie Du im Bewerbungsgespräch auf Augenhöhe bleibst',
        description:
          'Ein Vorstellungsgespräch kann eine herausfordernde Situation sein: Wer nicht auf Augenhöhe mit dem potenziellen Arbeitgeber bleibt, geht unter. Mit diesen Insider-Tipps lässt sich das verhindern.',
        url: 'https://www.xing.com/news/articles/mach-dich-nicht-kleiner-als-du-bist-8-tipps-wie-du-im-bewerbungsgesprach-auf-augenhohe-bleibst-5810741',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/782/305/square_48/7cf2737a4bf39eec3af0c914b82238a978f0c188image.jpg?1690451921',
      },
      {
        pageTitle: 'Bewerbung & Gehaltsverhandlung',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/531/038/web_high/d90dc932ca2f9987b099cc3bd97caae0e50c0cc2image.jpg?1571068069',
        title: 'Die fatalsten Fehler im Vorstellungsgespräch',
        description:
          'Bei einem Vorstellungsgespräch möchten Bewerber sich kompetent verkaufen und den guten Eindruck aus den Bewerbungsunterlagen unterstreichen. Doch wie punktet man am besten beim Personaler? Welche Pannen werden verziehen und welche Fehler sollten um jeden Preis vermieden werden?',
        url: 'https://www.xing.com/news/articles/die-fatalsten-fehler-im-vorstellungsgesprach-2696206',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/939/708/square_48/0237a55a3e4987ea2a9afdbfed060a544c5a5ba9image.jpg?1508772598',
      },
      {
        pageTitle: 'Job & Karriere',
        title:
          'Du willst im Vorstellungsgespräch beeindrucken? Mit diesen 5 Gewinnerfragen überraschst Du jeden Personaler',
        description:
          '"Und, haben Sie noch Fragen an uns?" Wir erklären Dir, wie Du im Job-Interview mit klugen Rückfragen final überzeugen kannst.',
        url: 'https://www.xing.com/news/articles/du-willst-im-vorstellungsgesprach-beeindrucken-mit-diesen-5-gewinnerfragen-uberraschst-du-jeden-personaler-5749660',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Ratgeber: Jobsuche',
        title:
          'Das Vorstellungsgespräch: So wird es ein Gespräch auf Augenhöhe',
        description:
          'Nervös? Dann denke daran: du prüfst genauso, ob das Unternehmen zu dir passt, wie umgekehrt. Mit Karrierecoach Bernd Slaghuis findest du das richtige Mindset.',
        url: 'https://www.xing.com/news/articles/das-vorstellungsgesprach-so-wird-es-ein-gesprach-auf-augenhohe-5183520',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/004/477/679/square_48/6230a66e7dc9011f64b609dd2ae054a457476828image.jpg?1646660839',
      },
      {
        pageTitle: 'Ratgeber: Jobsuche',
        title: 'Das Vorstellungsgespräch: So bereitest du dich vor',
        description:
          'Nervös? Das ist verständlich. Aber mit der richtigen Vorbereitung kann dich nichts überraschen. XING Insider und Karrierecoach Bernd Slaghuis kennt die Tricks.',
        url: 'https://www.xing.com/news/articles/das-vorstellungsgesprach-so-bereitest-du-dich-vor-5183499',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/004/477/679/square_48/6230a66e7dc9011f64b609dd2ae054a457476828image.jpg?1646660839',
      },
      {
        pageTitle: '',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZDNhYzNmZjYtOTJjMC00MDA0LWE5MDQtMjI5Y2Q0NzkwZmJkIiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=762d369dee18907f4c98cb8b201231465429fdd665e73df1a0287ef40d8e61ca',
        title:
          'Golfen, Segeln, Reiten – mit diesen Hobbys bekommst Du das Vorstellungsgespräch',
        description:
          'Die „richtigen“ Hobbys in der Bewerbung anzugeben kann große Vorteile haben. Denn sie beeinflussen nicht selten HR-Verantwortliche und Manager bei der Bewerberauswahl. ',
        url: 'https://www.xing.com/news/article/golfen-segeln-reiten-mit-diesen-hob',
        profileImage: '',
      },
      {
        pageTitle: 'Henryk Lüderitz',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZTJkYWVjMmYtNmQ5MS00YmVmLWEwNGYtYWY5NjQyNjU4OWE2IiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=090ddc28d4aeb2b7d772ff31e63f783528d91a891541df1f4f23f0fe4c222206',
        title:
          'Gehaltsfrage im Vorstellungsgespräch – diese drei Fehler musst du unbedingt vermeiden!',
        description:
          '„Was soll ich nur sagen, wenn ich im Vorstellungsgespräch auf mein Gehalt angesprochen werde?“ So selbstverständlich und nachvollziehbar die Gehaltsfrage auch ist, sie sorgt bei Bewerber:innen nach wie vor für Angst und Schrecken.',
        url: 'https://www.xing.com/news/article/gehaltsfrage-im-vorstellungsgesprae',
        profileImage:
          'https://profile-images.xing.com/images/cb252ad7461e882678d19dd781a4e127-12/henryk-l%C3%BCderitz.256x256.jpg',
      },
      {
        pageTitle: 'Dr. Branjo Woischwill',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZDI3YWJjMmUtOWQ2Ny00YTkwLTkxMmUtODZkODZlNTE5YWZjIiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=443226e37ceaa8252f8dd1047880da1c859f31fdbe2c2ba97ec40eab17ebbf78',
        title:
          'Genial oder gefährlich? Vorstellungsgesprächs-Training mit ChatGPT',
        description:
          'Vorbereitung mit ChatGPT auf ein Job-Interview? Bei einer Fähigkeit kann die KI nicht mithalten...',
        url: 'https://www.xing.com/news/article/genial-oder-gefaehrlich-vorstellung',
        profileImage:
          'https://profile-images.xing.com/images/79aaa3684abf509186c60a82700d77a2-4/branko-woischwill.256x256.jpg',
      },
      {
        pageTitle: 'Stefanie Saß',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZTVmODYxZDYtMWEwMy00MzkxLTgwNmYtYzZlNzE1MTJjNzM5IiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=b967b41bfc74789437fd02438a46cb9ff3b10dbce2221ac488c289be55279c3a',
        title: '27 clevere Rückfragen für Ihr nächstes Vorstellungsgespräch',
        description:
          'Zum Ende jedes Bewerbungsgesprächs haben Sie die Möglichkeit, Rückfragen zu stellen. Häufig sagen Bewerber*innen aus Angst, einen schlechten Eindruck zu hinterlassen, dass nach dem Gespräch keine Fragen offengeblieben sind.',
        url: 'https://www.xing.com/news/article/27-clevere-rueckfragen-fuer-ihr-nae',
        profileImage:
          'https://profile-images.xing.com/images/28d088ae83adb88a9c2ac72e6e046983-3/stefanie-sa%C3%9F.256x256.jpg',
      },
    ],
  },
  {
    articles: [
      {
        pageTitle: 'Nane Nebel',
        title: 'Sind Lücken im Lebenslauf Karrierekiller? Nein!',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/001/982/638/web_high/e67e91e2eb8d0f31838d983369fb5cf61cba5409image.jpg?1551713358',
        description:
          'Die besorgte Frage „Was mache ich bloß mit der Lücke in meinem Lebenslauf?“ lässt sich einfach beantworten: Gar nichts! Denn eine „Lücke“ ist ganz normal und keinesfalls ein Makel.',
        url: 'https://www.xing.com/news/insiders/articles/sind-lucken-im-lebenslauf-karrierekiller-nein-2110453',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/881/465/square_48/ed0d6b64dc93cf1144a279de7d04a197913af312image.jpg?1694434114',
      },
      {
        pageTitle: 'Vanessa Weber',
        title:
          'Sieben Lücken im Lebenslauf, die Deine Bewerbung nur interessanter machen',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/535/287/web_high/33a04cdcff1aa973cb01bea44e0dcf456dbb50edimage.jpg?1680779156',
        description:
          'Mut zur Lücke! Du hast die Phase zwischen zwei Jobs sinnvoll genutzt? Dann kehre sie bei der Bewerbung nicht unter den Teppich, sondern putze sie fein heraus.',
        url: 'https://www.xing.com/news/insiders/articles/sieben-lucken-im-lebenslauf-die-deine-bewerbung-nur-interessanter-machen-5630956',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/004/206/744/square_48/21343eabe7953c1e9e145a7e872125bd9f9972cdimage.jpg?1637574900',
      },
      {
        pageTitle: 'MICHAEL HANS HAHL',
        title:
          'Wenn der Lebenslauf zu jung und der Aufbau zu alt sind. Die Generation 50+ und ihr CV.',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/003/158/944/web_high/72afaeed78073aee7fbb3bcb295f78a73d79eab5image.jpg?1594892734',
        description:
          'Der CV oder für erfahrene Berufler auch Lebenslauf genannt, wird meiner Meinung nach in Zukunft immer mehr an Bedeutung gewinnen. Fällt das Anschreiben irgendwann weg, davon gehe ich aus, ist der Siegeszug des CV’s nicht mehr aufzuhalten.',
        url: 'https://www.xing.com/news/insiders/articles/wenn-der-lebenslauf-zu-jung-und-der-aufbau-zu-alt-sind-die-generation-50-und-ihr-cv-3341946',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/174/690/square_48/d4fb0159ac82014bf8c0702998171f1656d01241image.jpg?1667293710',
      },
      {
        pageTitle: 'Tanja Jakob',
        title:
          'Karrierebruch oder wertvolle Erfahrung? Elternzeit im Lebenslauf gekonnt in Szene setzen',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/757/954/web_high/17ffcea920ee6956fd1d1861ae5120b55bfc6803image.jpg?1689585055',
        description:
          'Viele berufstätige Mütter fragen sich, wie sie die Elternzeit im Lebenslauf angeben und ihre neu erworbenen Fähigkeiten als Mutter im Lebenslauf als wertvolle Erfahrungen präsentieren können.',
        url: 'https://www.xing.com/news/insiders/articles/karrierebruch-oder-wertvolle-erfahrung-elternzeit-im-lebenslauf-gekonnt-in-szene-setzen-5853503',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/738/136/square_48/690b45f3acf9853d0eedb52df8acd518339b60edimage.jpg?1688725982',
      },
      {
        pageTitle: 'Dr. Bernd Slaghuis',
        title:
          'Teilzeit im Lebenslauf angeben? Warum es für deine Berufserfahrung egal ist, wie lange du im Büro gesessen hast',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/004/908/203/web_high/fa62863e3b2fc001667208bfba4a5e6587885c66image.jpg?1656965569',
        description:
          'Muss eine Position in Teilzeit im Lebenslauf als solche kenntlich gemacht werden? Der Fall von Laura Dornheim und ihrer geplatzten Wahl zu Münchens neuer IT-Referentin sorgt für viel Diskussion im Netz.  ',
        url: 'https://www.xing.com/news/insiders/articles/teilzeit-im-lebenslauf-angeben-warum-es-fur-deine-berufserfahrung-egal-ist-wie-lange-du-im-buro-gesessen-hast-4979004',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/786/767/square_48/1fc60bb470b3e42e790126a6eb6529183981db0eimage.jpg?1690622987',
      },
      {
        pageTitle: 'Silke Koppitz',
        title:
          '5 „Beige Flags“ in deinem Lebenslauf, die du sofort loswerden solltest',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/703/564/web_high/9ff8602922464fa92364f1d51e61cecd14ea9058image.jpg?1687440267',
        description:
          '„Zu Vino sag ich nie no!“, „Tschö mit ö!“, „Mal verliert man, und mal gewinnen die anderen!“ oder „Lange nicht gesehen und doch wiedererkannt!“. ',
        url: 'https://www.xing.com/news/insiders/articles/5-beige-flags-in-deinem-lebenslauf-die-du-sofort-loswerden-solltest-5800761',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/504/323/square_48/806bca39750db92d12d4ad6c89bf073b6cfc43f7image.jpg?1679654675',
      },
      {
        pageTitle: 'Job & Karriere',
        title: 'Lebenslauf verfassen: Diese 5 Artikel sollten Sie kennen',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/000/693/235/web_high/c4b22111bcbc2b406e944c4a3d1942a442614b12image.jpg?1495628633',
        description:
          'Regelmäßig empfehlen wir Ihnen lesenswerte Beiträge aus dem Bereich „Job & Karriere“. Heute stellen wir die fünf besten Artikel zum Thema Lebenslauf vor:',
        url: 'https://www.xing.com/news/articles/lebenslauf-verfassen-diese-5-artikel-sollten-sie-kennen-745074',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Job & Karriere',
        title:
          'Karriere-Coach zu Lebenslaufpannen: So überarbeitest Du Deinen CV richtig',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/003/865/609/web_high/1091321b68e7bcfbf81d06e183ef75c8f5acef7cimage.jpg?1623247333',
        description:
          'Die Kanzlerkandidaten Baerbock und Laschet stehen wegen Lebenslaufpannen in der Kritik. Heißt das, jetzt besonders demütig beim Erstellen des eigenen CVs zu sein? Auf keinen Fall, sagt der Karriere-Coach. ',
        url: 'https://www.xing.com/news/articles/karriere-coach-zu-lebenslaufpannen-so-uberarbeitest-du-deinen-cv-richtig-4061531',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Job & Karriere',
        title:
          'Setz diese 7 Akzente in Deinem Lebenslauf, um ihn für Personaler unwiderstehlich zu machen',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/005/650/639/web_high/cb532d1f5c0fec4ba64cb3e489caf31de5a6f9cbimage.jpg?1685465354',
        description:
          'Brauchst Du Hilfe, um Deine Arbeitserfahrung überzeugend darzustellen? Befolge diese Tipps in Deinem Lebenslauf, um Deine Chance auf das Vorstellungsgespräch zu maximieren.',
        url: 'https://www.xing.com/news/articles/setz-diese-7-akzente-in-deinem-lebenslauf-um-ihn-fur-personaler-unwiderstehlich-zu-machen-5718120',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Bewerbung & Gehaltsverhandlung',
        title:
          'Grundschule, Elternzeit & Co: Was gehört in den Lebenslauf – und was nicht?',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/615/049/web_high/f0ab2dbe21bb6b4991ca182d831ffd6f494e49d4image.jpg?1573730790',
        description:
          'Der Lebenslauf ist für viele Personaler die wichtigste Entscheidungsgrundlage dafür, welche Bewerber sie zum Vorstellungsgespräch einladen. Seine Inhalte müssen also auf den Punkt überzeugen. Das bedeutet auch, einige Dinge bewusst zu verschweigen…',
        url: 'https://www.xing.com/news/articles/grundschule-elternzeit-co-was-gehort-in-den-lebenslauf-und-was-nicht-2786197',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/939/708/square_48/0237a55a3e4987ea2a9afdbfed060a544c5a5ba9image.jpg?1508772598',
      },
      {
        pageTitle: 'Job & Karriere',
        title:
          'Die schlimmsten Fehler im Lebenslauf - Diese 4 Artikel sollten Sie kennen',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/001/626/548/web_high/40c49f6276d1c2d62420568cab1f9f5356cbd63dimage.jpg?1538058568',
        description:
          'Was bewegt die Arbeitswelt heute? In unserer Artikelsammlung erklären wir aktuelle Aspekte, beleuchten unterschiedliche Perspektiven und empfehlen Hintergrundbeiträge – direkt aus der XING-Redaktion.',
        url: 'https://www.xing.com/news/articles/die-schlimmsten-fehler-im-lebenslauf-diese-4-artikel-sollten-sie-kennen-1719337',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Job & Karriere',
        title: 'Die 7 größten Irrtümer: Dos und Don‘ts beim Lebenslauf',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/000/746/154/web_high/cd89d15841a28914597d1c3bcc3bdcbabff38b52image.jpg?1498729472',
        description:
          'Der Lebenslauf - oder CV - ist das wohl wichtigste Dokument im gesamten Bewerbungsprozess. Vermutlich ranken sich deshalb auch diverse Gerüchte um ihn. Worauf es beim Lebenslauf wirklich ankommt, lesen Sie hier: Wir haben Ihnen die sieben größten Irrtümer rund um den Lebenslauf zusammengestellt – und räumen mit ihnen auf!',
        url: 'https://www.xing.com/news/articles/die-7-grossten-irrtumer-dos-und-don-ts-beim-lebenslauf-800699',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Job & Karriere',
        title: 'Aufbau und Inhalt eines perfekten Lebenslaufs',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/001/256/867/web_high/c5945da01079c28c1db4b8123ab394aeb4cdc95cimage.jpg?1523541924',
        description:
          'Was bewegt die Arbeitswelt heute? Wir erklären aktuelle Aspekte, beleuchten unterschiedliche Perspektiven und empfehlen Hintergrundbeiträge – direkt aus der XING-Redaktion.',
        url: 'https://www.xing.com/news/articles/aufbau-und-inhalt-eines-perfekten-lebenslaufs-1332681',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Ratgeber: Jobsuche',
        title: 'Der Lebenslauf: Design und Umfang',
        description:
          'Du aktualisierst deinen Lebenslauf und hast plötzlich lauter Fragen: Wie lang soll er sein? Braucht er Foto, Deckblatt und ein Anschreiben? Tipps vom Experten.',
        url: 'https://www.xing.com/news/articles/der-lebenslauf-design-und-umfang-5179832',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/004/477/679/square_48/6230a66e7dc9011f64b609dd2ae054a457476828image.jpg?1646660839',
      },
      {
        pageTitle: 'Ratgeber: Jobsuche',
        title: 'Der Lebenslauf: Struktur und Inhalte',
        description:
          'Was ist eigentlich wichtig? Für den optimal aufbereiteten Lebenslauf hat Karrierecoach und XING Insider Dr. Bernd Slaghuis die wichtigsten Punkte zusammengefasst.',
        url: 'https://www.xing.com/news/articles/der-lebenslauf-struktur-und-inhalte-5196846',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/004/477/679/square_48/6230a66e7dc9011f64b609dd2ae054a457476828image.jpg?1646660839',
      },
      {
        pageTitle: 'Selma Kuyas',
        title: 'Lücke im Lebenslauf – Tipps für eine erfolgreiche Bewerbung',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiMTZlMmE4NDAtOGUxNS00NjdiLWFmZDktNzY0YWMyYjhiMzM0IiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=ffb7bcdead0870e26c39482ee803ff2d433039b326f3d714383ed26449fd8f54',
        description:
          'Hast Du Bedenken oder sogar Angst, eine Bewerbung an Arbeitgeber zu schicken, weil es eine Lücke im Lebenslauf gibt?',
        url: 'https://www.xing.com/news/article/luecke-im-lebenslauf-tipps-fuer-eine-erfolgreiche-bewerbung',
        profileImage:
          'https://profile-images.xing.com/images/9ce064edcb767fb21919b884e0b7f53f-20/selma-kuyas.256x256.jpg',
      },
      {
        pageTitle: '',
        title:
          'Golfen, Segeln, Reiten – mit diesen Hobbys bekommst Du das Vorstellungsgespräch',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZDNhYzNmZjYtOTJjMC00MDA0LWE5MDQtMjI5Y2Q0NzkwZmJkIiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=762d369dee18907f4c98cb8b201231465429fdd665e73df1a0287ef40d8e61ca',
        description:
          'Die „richtigen“ Hobbys in der Bewerbung anzugeben kann große Vorteile haben. Denn sie beeinflussen nicht selten HR-Verantwortliche und Manager bei der Bewerberauswahl.',
        url: 'https://www.xing.com/news/article/golfen-segeln-reiten-mit-diesen-hob',
        profileImage: '',
      },
      {
        pageTitle: 'Claus Verfürth',
        title:
          'Bewerben als Top-Führungskraft: So wird Ihr CV zum Türöffner für Ihre neue Spitzenposition',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiYjMxOWRjM2MtMTRmMS00MTdmLTllMGEtNzFhNDlhMTc4MTU4IiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=aba81dbdb3d4ff8069a722d6cbc2d45887471f91f86dd0b56590b0e893d60c44',
        description:
          'Wer sich als Top-Führungskraft bewerben will, sollte auch einige Besonderheiten beachten, die für eine Bewerbung im Topmanagement gelten.',
        url: 'https://www.xing.com/news/article/bewerben-als-top-fuehrungskraft-so',
        profileImage:
          'https://profile-images.xing.com/images/c052d770c9da1e8c2b321d69fdab7e9a-4/claus-verf%C3%BCrth.256x256.jpg',
      },
    ],
  },
];

export const SubtopicPagesData = new Map<string, SubtopicData>([
  ['besondere-bewerbung', SubtopicData[0]],
  ['bewerbungsarten-formate', SubtopicData[1]],
  ['anschreiben', SubtopicData[2]],
  ['vorstellungsgespräch', SubtopicData[3]],
  ['lebenslauf', SubtopicData[4]],
]);
